export enum SidebarItems {
  DASHBOARD = 'Dashboard',
  USERS = 'Users',
  DOCTORS_NURSES = 'Doctors&Nurses',
  FINANCE = 'Finance',
  DAILY_USERS_REMINDER = 'Daily users reminder',
  AWARENESS_CARDS = 'Awareness cards',
  URGENT_NOTIFICATION = 'Urgent notification',
  COMMISSION_RATES_PRICING = 'Commission rates & pricing',
  ADMINS = 'Admins',
  APP_CONTENT = 'App content',
  ONBOARDING_VIDEOS = 'Intro & onboarding videos',
  SMS_DELIVERY = 'SMS delivery',
  SMS_CODES = 'SMS & codes',
  ACCOUNT_DELETIONS = 'Closed accounts',
}
